import Swiper from 'swiper/bundle'

export default class HeroSlider {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    const swiperEl = this.el.querySelector('.swiper')
    if (!swiperEl) return

    this.swiper = new Swiper(swiperEl, {
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: swiperEl.querySelector('.hero-slider--pagination'),
        clickable: true,
      },
    })
  }
}
